import { faTypo3 } from "@fortawesome/free-brands-svg-icons";
import createField from "../../utils/factory/createField";
import {
  faCalendarAlt,
  faMoneyBillWave,
  faBoxOpen,
  faTools,
  faClipboardCheck,
  faToggleOn,
  faDollarSign,
  faPen,
  faFileAlt,
  faUser,
  faBuilding,
  faFileSignature,
} from "@fortawesome/free-solid-svg-icons";

export const dynamicFields = {
  1: [
    {
      section: "Informações do Contrato",
      fields: [
        createField({
          id: "info.start_date",
          label: "Data Início",
          type: "date",
          icon: faCalendarAlt,
        }),
        createField({
          id: "info.total_amount",
          label: "Valor Total",
          type: "number",
          placeholder: "Digite o Valor Total",
          icon: faMoneyBillWave,
        }),
        createField({
          id: "info.end_date",
          label: "Data Término",
          type: "date",
          icon: faCalendarAlt,
        }),
        createField({
          id: "info.max_end_date",
          label: "Data Término Máxima",
          type: "date",
          icon: faCalendarAlt,
        }),
        createField({
          id: "info.duration",
          label: "Duração",
          type: "number",
          placeholder: "Digite a Duração",
          icon: faCalendarAlt,
        }),
        createField({
          id: "info.max_duration",
          label: "Duração Máxima",
          type: "number",
          placeholder: "Digite a Duração Máxima",
          icon: faCalendarAlt,
        }),
      ],
    },
    {
      section: "Items",
      array: true,
      count: 0,
      fields: [
        createField({
          id: "items.alias",
          label: "Nome do item",
          type: "text",
          placeholder: "Digite o nome do item",
          fullWidth: true,
          icon: faBoxOpen,
        }),
        createField({
          id: "items.description",
          label: "Descrição",
          type: "textarea",
          placeholder: "Digite a Descrição",
          fullWidth: true,
          icon: faBoxOpen,
        }),
        createField({
          id: "items.quantity",
          label: "Quantidade",
          type: "number",
          placeholder: "Digite a Quantidade",
          icon: faBoxOpen,
        }),
        createField({
          id: "items.price",
          label: "Preço",
          type: "number",
          placeholder: "Digite o Preço",
          icon: faMoneyBillWave,
        }),
      ],
    },
    {
      section: "Serviços",
      array: true,
      count: 0,
      fields: [
        createField({
          id: "jobs.alias",
          label: "Nome",
          type: "text",
          placeholder: "Digite o nome",
          fullWidth: true,
          icon: faTools,
        }),
        createField({
          id: "jobs.description",
          label: "Descrição",
          type: "textarea",
          placeholder: "Digite a Descrição",
          fullWidth: true,
          icon: faTools,
        }),
        createField({
          id: "jobs.quantity",
          label: "Quantidade",
          type: "number",
          placeholder: "Digite a Quantidade",
          icon: faBoxOpen,
        }),
        createField({
          id: "jobs.price",
          label: "Preço",
          type: "number",
          placeholder: "Digite o Preço",
          icon: faMoneyBillWave,
        }),
      ],
    },
  ],
  2: [
    {
      section: "Aditivo de Prazo",
      fields: [
        createField({
          id: "info.end_date",
          label: "Data Término",
          type: "date",
          icon: faCalendarAlt,
          fullWidth: true,
        }),
      ],
    },
  ],
  3: [
    {
      section: "Aditivo de Quantidade",
      array: true,
      fields: [
        createField({
          id: "items_addition.identify",
          label: "Identificador",
          type: "text",
          placeholder: "Identificador",
          icon: faToggleOn,
          disabled: true,
          fullWidth: true,
        }),
        createField({
          id: "items_addition.new",
          label: "Novo Item:",
          type: "select",
          placeholder: "Cadastro de Novo Item?",
          options: [
            { value: true, label: "Sim" },
            { value: false, label: "Não" },
          ],
          icon: faToggleOn,
        }),
        createField({
          id: "items_addition.item_id",
          label: "Número Item",
          type: "text",
          icon: faBoxOpen,
          placeholder: "Digite o identificador do item",
        }),
        createField({
          id: "items_addition.quantity",
          label: "Quantidade",
          type: "number",
          placeholder: "Digite a Quantidade",
          icon: faBoxOpen,
        }),
      ],
    },
  ],
  4: [
    {
      section: "Aditivo de Reajuste",
      array: true,
      fields: [
        createField({
          id: "items_addition.identify",
          label: "Identificador",
          type: "text",
          placeholder: "Identificador",
          icon: faToggleOn,
          disabled: true,
          fullWidth: true,
        }),
        createField({
          id: "items_addendum.item_id",
          label: "Número Item",
          type: "text",
          icon: faBoxOpen,
          placeholder: "Digite o identificador do item",
        }),
        createField({
          id: "items_addendum.price",
          label: "Preço",
          type: "number",
          placeholder: "Digite o preço",
          icon: faMoneyBillWave,
        }),
      ],
    },
  ],
  5: [
    {
      section: "Aditivo de Supressão",
      array: true,
      fields: [
        createField({
          id: "items_supression.identify",
          label: "Identificador",
          type: "text",
          placeholder: "Identificador",
          icon: faToggleOn,
          disabled: true,
          fullWidth: true,
        }),
        createField({
          id: "items_supression.item_id",
          label: "Número Item",
          type: "text",
          icon: faBoxOpen,
          placeholder: "Digite o identificador do item",
        }),
        createField({
          id: "items_supression.quantity",
          label: "Quantidade",
          type: "number",
          placeholder: "Digite a Quantidade",
          icon: faBoxOpen,
        }),
      ],
    },
  ],
};

export const baseEventFields = [
  {
    section: "Tipo Evento",
    fields: [
      createField({
        id: "event.contract_event_type_id",
        label: "Tipo Evento",
        type: "multi-select",
        placeholder: "Selecione o tipo do evento",
        fullWidth: true,
        icon: faClipboardCheck,
        isMulti: true,
      }),
    ],
  },
];

export const editEventFields = [
  {
    section: "Dados do Evento",
    fields: [
      createField({
        id: "event.contract_event_type_id",
        label: "Tipo Evento",
        type: "multi-select",
        placeholder: "Selecione o tipo do evento",
        fullWidth: true,
        icon: faClipboardCheck,
        isMulti: true,
      }),
    ],
  },
];

export const detailsEventFields = [
  {
    section: "Dados do Evento",
    fields: [
      createField({
        id: "eventType",
        label: "Tipo Evento",
        type: "text",
        placeholder: "Selecione o tipo do evento",
        icon: faClipboardCheck,
      }),
      createField({
        id: "contract",
        label: "Contrato",
        type: "text",
        placeholder: "Selecione o contrato",
        icon: faClipboardCheck,
      }),
    ],
  },
];

export const eventFieldsDynamic = [
  {
    section: "Adicionar Evento",
    fields: [
      createField({
        id: "event.contract_event_type_id",
        label: "Tipo Evento",
        type: "multi-select",
        placeholder: "Selecione o tipo do evento",
        fullWidth: true,
        icon: faClipboardCheck,
        isMulti: true,
      }),
      createField({
        id: "event.event_date",
        label: "Data do Aditivo",
        type: "date",
        placeholder: "DD/MM/AAAA",
        icon: faCalendarAlt,
        fullWidth: true,
      })
    ],
  },
  {
    section: "Informações",
    fields: [
      createField({
        id: "contract.name",
        label: "Contrato",
        type: "text",
        placeholder: "Digite o nome do contrato",
        icon: faFileSignature,
      }),
      createField({
        id: "contract.number",
        label: "Número",
        type: "text",
        placeholder: "Digite o número do contrato",
        icon: faFileAlt,
      }),
      createField({
        id: "contract.contract_type_id",
        label: "Tipo",
        type: "select",
        placeholder: "Selecione o tipo",
        icon: faClipboardCheck,
      }),
      createField({
        id: "contract.contract_status_id",
        label: "Status",
        type: "select",
        placeholder: "Selecione o status",
        icon: faClipboardCheck,
      }),
      createField({
        id: "contract.organization_id",
        label: "Organização",
        type: "select",
        placeholder: "Selecione a organização",
        icon: faBuilding,
      }),
      createField({
        id: "contract.customer_id",
        label: "Contratante",
        type: "select",
        placeholder: "Selecione o cliente contratante",
        icon: faUser,
      }),
      createField({
        id: "contract.object",
        label: "Cláusula",
        type: "textarea",
        fullWidth: true,
        placeholder: "Digite o número do contrato",
        icon: faFileAlt,
      }),
      createField({
        id: "info.duration",
        label: "Duração",
        type: "number",
        placeholder: "Digite a duração",
        icon: faCalendarAlt,
      }),
      createField({
        id: "info.max_duration",
        label: "Duração Máxima",
        type: "number",
        placeholder: "Digite a duração máxima",
        icon: faCalendarAlt,
      }),
      createField({
        id: "info.start_date",
        label: "Data Início",
        type: "text",
        placeholder: "Digite a data de início",
        icon: faCalendarAlt,
      }),
      createField({
        id: "info.total_amount",
        label: "Valor Total",
        type: "text",
        formatType: "currency",
        isNumericFormat: true,
        placeholder: "Digite o valor total",
        icon: faMoneyBillWave,
        disabled: true,
      }),
      createField({
        id: "info.end_date",
        label: "Data Término",
        type: "text",
        placeholder: "Digite a data de término",
        icon: faCalendarAlt,
      }),
      createField({
        id: "info.max_end_date",
        label: "Data Término Máxima",
        type: "text",
        placeholder: "Digite a data de término máxima",
        icon: faCalendarAlt,
      }),
    ],
    itemSection: {
      section: "Itens do Contrato",
      description: "Selecione os itens para correção textual",
      fields: [
        createField({
          id: "items.alias",
          label: "Apelido do item do contrato",
          type: "text",
          icon: faBoxOpen,
          fullWidth: true,
          placeholder: "Digite o apelido do item do contrato",
        }),
        createField({
          id: "items.description",
          label: "Descrição do item do contrato",
          type: "textarea",
          icon: faBoxOpen,
          placeholder: "Digite a descrição do item do contrato",
          fullWidth: true,
        }),
        createField({
          id: "items.quantity",
          label: "Quantidade",
          type: "number",
          formatType: "integer",
          placeholder: "Digite a Quantidade",
          icon: faBoxOpen,
          isNumericFormat: true,
        }),
        createField({
          id: "items.price",
          label: "Preço",
          type: "number",
          placeholder: "Digite o preço do item",
          icon: faDollarSign,
          isNumericFormat: true,
        }),
      ],
    },
    jobSection: {
      section: "Serviços",
      description: "Selecione os serviços para correção textual",
      fields: [
        createField({
          id: "jobs.alias",
          label: "Apelido do serviço do contrato",
          type: "text",
          fullWidth: true,
          icon: faBoxOpen,
          placeholder: "Digite o apelido do serviço do contrato",
        }),
        createField({
          id: "jobs.description",
          label: "Descrição do serviço do contrato",
          type: "textarea",
          icon: faBoxOpen,
          placeholder: "Digite a descrição do serviço do contrato",
          fullWidth: true,
        }),
        createField({
          id: "jobs.quantity",
          label: "Quantidade",
          type: "number",
          formatType: "integer",
          placeholder: "Digite a Quantidade",
          icon: faBoxOpen,
          isNumericFormat: true,
        }),
        createField({
          id: "jobs.price",
          label: "Preço",
          type: "number",
          placeholder: "Digite o preço do serviço",
          icon: faDollarSign,
          isNumericFormat: true,
        }),
      ],
    },
  },
  {
    section: "Aditivo de Prazo",
    description: "Prolonge o prazo do contrato, atualizando a data de término.",
    fields: [
      createField({
        id: "aditionTerm.end_date",
        label: "Data Término",
        type: "date",
        placeholder: "DD/MM/AAAA",
        icon: faCalendarAlt,
        fullWidth: true,
      }),
    ],
  },
  {
    section: "Aditivo de Quantidade ",
    description: "Adicione ou atualize a quantidade de um item do contrato.",
    array: true,
    fields: [
      createField({
        id: "aditionQuantity.new",
        label: "Adicionar item ao contrato?",
        type: "select",
        icon: faToggleOn,
        placeholder: "Deseja adicionar um novo item ao contrato?",
      }),
      createField({
        id: "aditionQuantity.contract_item_id",
        label: "Item do contrato",
        type: "select",
        icon: faBoxOpen,
        placeholder: "Selecione o item do contrato",
      }),
      createField({
        id: "aditionQuantity.alias",
        label: "Apelido do item do contrato",
        type: "text",
        icon: faBoxOpen,
        placeholder: "Digite o apelido do item do contrato",
      }),
      createField({
        id: "aditionQuantity.quantity",
        label: "Quantidade",
        type: "number",
        formatType: "integer",
        placeholder: "Digite a Quantidade",
        icon: faBoxOpen,
        isNumericFormat: true,
      }),
      createField({
        id: "aditionQuantity.price",
        label: "Preço",
        type: "number",
        placeholder: "Digite o preço do item",
        icon: faDollarSign,
        isNumericFormat: true,
        disabled: true,
      }),
      createField({
        id: "aditionQuantity.description",
        label: "Descrição",
        type: "textarea",
        icon: faPen,
        placeholder: "Digite a descrição do item",
        fullWidth: true,
        disabled: true,
      }),
    ],
  },
  {
    section: "Aditivo de Reajuste",
    description: "Atualiza o preço de um item do contrato.",
    array: true,
    fields: [
      createField({
        id: "aditionPrice.item_or_job",
        label: "Tipo do item",
        type: "select",
        icon: faTypo3,
        fullWidth: true,
        placeholder: "Selecione o tipo do item",
      }),
      createField({
        id: "aditionPrice.contract_item_id",
        label: "Item do contrato",
        type: "select",
        icon: faBoxOpen,
        placeholder: "Selecione o item do contrato",
      }),
      createField({
        id: "aditionPrice.contract_job_id",
        label: "Serviço do contrato",
        type: "select",
        icon: faTools,
        placeholder: "Selecione o serviço do contrato",
      }),
      createField({
        id: "aditionPrice.price",
        label: "Preço",
        type: "number",
        placeholder: "Digite o preço",
        icon: faMoneyBillWave,
        isNumericFormat: true,
      }),
    ],
  },
  {
    section: "Aditivo de Supressão",
    description: "Diminui a quantidade de um item do contrato",
    array: true,
    fields: [
      createField({
        id: "aditionSupression.contract_item_id",
        label: "Item do contrato",
        type: "select",
        icon: faBoxOpen,
        placeholder: "Selecione o item do contrato",
      }),
      createField({
        id: "aditionSupression.quantity",
        label: "Quantidade",
        type: "number",
        formatType: "integer",
        placeholder: "Digite a Quantidade",
        icon: faBoxOpen,
        isNumericFormat: true,
      }),
    ],
  },
  {
    section: "Aditivo de Modificação de Item ",
    description:
      "Permite modificar por completo o item do contrato, alterando tanto a quantidade quanto o preço.",
    array: true,
    fields: [
      createField({
        id: "aditionModifyItem.contract_item_id",
        label: "Item do contrato",
        type: "select",
        icon: faBoxOpen,
        placeholder: "Selecione o item do contrato",
      }),
      createField({
        id: "aditionModifyItem.alias",
        label: "Apelido do item do contrato",
        type: "text",
        icon: faBoxOpen,
        placeholder: "Digite o apelido do item do contrato",
      }),
      createField({
        id: "aditionModifyItem.quantity",
        label: "Quantidade",
        type: "number",
        placeholder: "Digite a Quantidade",
        icon: faBoxOpen,
        isNumericFormat: true,
      }),
      createField({
        id: "aditionModifyItem.price",
        label: "Preço",
        type: "number",
        placeholder: "Digite o preço do item",
        icon: faDollarSign,
        isNumericFormat: true,
      }),
      createField({
        id: "aditionModifyItem.description",
        label: "Descrição",
        type: "textarea",
        icon: faPen,
        placeholder: "Digite a descrição do item",
        fullWidth: true,
      }),
    ],
  },
  {
    section: "Apostilamento",
    description:
      "Permite realizar alterações formais no contrato, como atualização de dotação orçamentária ou correção de dados, sem modificar o objeto ou as condições principais.",
    fields: [
      createField({
        id: "aditionContractAmendment.start_date",
        label: "Data Início",
        type: "date",
        placeholder: "DD/MM/AAAA",
        icon: faCalendarAlt,
      }),
      createField({
        id: "aditionContractAmendment.end_date",
        label: "Data Término",
        type: "date",
        placeholder: "DD/MM/AAAA",
        icon: faCalendarAlt,
      }),
      createField({
        id: "aditionContractAmendment.max_end_date",
        label: "Data Término Máxima",
        type: "date",
        placeholder: "DD/MM/AAAA",
        icon: faCalendarAlt,
      }),
      createField({
        id: "aditionContractAmendment.duration",
        label: "Duração",
        type: "number",
        placeholder: "Digite a Duração",
        icon: faCalendarAlt,
      }),
      createField({
        id: "aditionContractAmendment.max_duration",
        label: "Duração Máxima",
        type: "number",
        placeholder: "Digite a Duração Máxima",
        icon: faCalendarAlt,
        fullWidth: true,
      }),
    ],
    itemSection: {
      section: "Itens do Contrato",
      description: "Selecione os itens para correção textual",
      fields: [
        createField({
          id: "items.contract_item_id",
          label: "Item do Contrato",
          type: "select",
          icon: faBoxOpen,
          placeholder: "Selecione o item do contrato",
        }),
        createField({
          id: "items.alias",
          label: "Apelido do item do contrato",
          type: "text",
          icon: faBoxOpen,
          placeholder: "Digite o apelido do item do contrato",
        }),
        createField({
          id: "items.description",
          label: "Descrição do item do contrato",
          type: "textarea",
          icon: faBoxOpen,
          placeholder: "Digite a descrição do item do contrato",
          fullWidth: true,
        }),
      ],
    },
    jobSection: {
      section: "Serviços",
      description: "Selecione os serviços para correção textual",
      fields: [
        createField({
          id: "jobs.contract_job_id",
          label: "Serviço do Contrato",
          type: "select",
          icon: faBoxOpen,
          placeholder: "Selecione o serviço do contrato",
        }),
        createField({
          id: "jobs.alias",
          label: "Apelido do serviço do contrato",
          type: "text",
          icon: faBoxOpen,
          placeholder: "Digite o apelido do serviço do contrato",
        }),
        createField({
          id: "jobs.description",
          label: "Descrição do serviço do contrato",
          type: "textarea",
          icon: faBoxOpen,
          placeholder: "Digite a descrição do serviço do contrato",
          fullWidth: true,
        }),
      ],
    },
  },
];

export const editEventFieldsDynamic = [
  {
    section: "Informações do Contrato",
    fields: [
      createField({
        id: "info.start_date",
        label: "Data Início",
        type: "date",
        icon: faCalendarAlt,
      }),
      createField({
        id: "info.total_amount",
        label: "Valor Total",
        type: "number",
        isNumericFormat: true,
        placeholder: "Digite o Valor Total",
        icon: faMoneyBillWave,
      }),
      createField({
        id: "info.end_date",
        label: "Data Término",
        type: "date",
        icon: faCalendarAlt,
      }),
      createField({
        id: "info.max_end_date",
        label: "Data Término Máxima",
        type: "date",
        icon: faCalendarAlt,
      }),
      createField({
        id: "info.duration",
        label: "Duração",
        type: "number",
        placeholder: "Digite a Duração",
        icon: faCalendarAlt,
      }),
      createField({
        id: "info.max_duration",
        label: "Duração Máxima",
        type: "number",
        placeholder: "Digite a Duração Máxima",
        icon: faCalendarAlt,
      }),
    ],
  },
  {
    section: "Items",
    array: true,
    fields: [
      createField({
        id: "items.alias",
        label: "Número",
        type: "text",
        placeholder: "Digite o Identificador do item",
        fullWidth: true,
        icon: faBoxOpen,
      }),
      createField({
        id: "items.description",
        label: "Descrição",
        type: "textarea",
        placeholder: "Digite a Descrição",
        fullWidth: true,
        icon: faBoxOpen,
      }),
      createField({
        id: "items.quantity",
        label: "Quantidade",
        type: "number",
        placeholder: "Digite a Quantidade",
        icon: faBoxOpen,
        isNumericFormat: true,
      }),
      createField({
        id: "items.price",
        label: "Preço",
        type: "number",
        placeholder: "Digite o Preço",
        icon: faMoneyBillWave,
        isNumericFormat: true,
      }),
    ],
  },
  {
    section: "Serviços",
    array: true,
    fields: [
      createField({
        id: "jobs.alias",
        label: "Nome",
        type: "text",
        placeholder: "Digite o Identificador",
        fullWidth: true,
        icon: faTools,
      }),
      createField({
        id: "jobs.description",
        label: "Descrição",
        type: "textarea",
        placeholder: "Digite a Descrição",
        fullWidth: true,
        icon: faTools,
      }),
      createField({
        id: "jobs.quantity",
        label: "Quantidade",
        type: "text",
        placeholder: "Digite a Quantidade",
        icon: faBoxOpen,
        isNumericFormat: true,
        formatType: "integer",
      }),
      createField({
        id: "jobs.price",
        label: "Preço",
        type: "number",
        isNumericFormat: true,
        placeholder: "Digite o Preço",
        icon: faMoneyBillWave,
        formatType: "currency",
      }),
    ],
  },
  {
    section: "Dados do Evento",
    fields: [
      createField({
        id: "event.contract_event_type_id",
        label: "Tipo Evento",
        type: "multi-select",
        placeholder: "Selecione o tipo do evento",
        fullWidth: true,
        icon: faClipboardCheck,
        isMulti: true,
      }),
      createField({
        id: "event.event_date",
        label: "Data do Aditivo",
        type: "date",
        placeholder: "DD/MM/AAAA",
        icon: faCalendarAlt,
        fullWidth: true,
      })
    ],
  },
  {
    section: "Aditivo de Prazo",
    fields: [
      createField({
        id: "aditionTerm.end_date",
        label: "Data Término",
        type: "date",
        icon: faCalendarAlt,
        fullWidth: true,
      }),
    ],
  },
  {
    section: "Aditivo de Quantidade",
    array: true,
    fields: [
      createField({
        id: "aditionQuantity.new",
        label: "Novo Item:",
        type: "select",
        placeholder: "Cadastro de Novo Item?",
        icon: faToggleOn,
      }),
      createField({
        id: "aditionQuantity.item_id",
        label: "Número Item",
        type: "text",
        icon: faBoxOpen,
        placeholder: "Digite o identificador do item",
      }),
      createField({
        id: "aditionQuantity.quantity",
        label: "Quantidade",
        type: "number",
        placeholder: "Digite a Quantidade",
        icon: faBoxOpen,
        isNumericFormat: true,
      }),
      createField({
        id: "aditionQuantity.price",
        label: "Preço",
        type: "number",
        placeholder: "Digite o preço do item",
        icon: faDollarSign,
        isNumericFormat: true,
        disabled: true,
      }),
      createField({
        id: "aditionQuantity.description",
        label: "Descrição",
        type: "textarea",
        icon: faPen,
        placeholder: "Digite a descrição do item",
        fullWidth: true,
        disabled: true,
      }),
    ],
  },
  {
    section: "Aditivo de Reajuste",
    array: true,
    fields: [
      createField({
        id: "aditionPrice.item_id",
        label: "Número Item",
        type: "text",
        icon: faBoxOpen,
        placeholder: "Digite o identificador do item",
      }),
      createField({
        id: "aditionPrice.price",
        label: "Preço",
        type: "number",
        placeholder: "Digite o preço",
        icon: faMoneyBillWave,
        isNumericFormat: true,
      }),
    ],
  },
  {
    section: "Aditivo de Supressão",
    array: true,
    fields: [
      createField({
        id: "aditionSupression.item_id",
        label: "Número Item",
        type: "text",
        icon: faBoxOpen,
        placeholder: "Digite o identificador do item",
      }),
      createField({
        id: "aditionSupression.quantity",
        label: "Quantidade",
        type: "number",
        placeholder: "Digite a Quantidade",
        icon: faBoxOpen,
        isNumericFormat: true,
      }),
    ],
  },
];
